import api from '@/libs/axiosInstance';
import type {
  AffiliateDetailsResponse,
  CommissionTypes,
  DiscountCodeTypes,
} from '@fluenceur/types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

// Helper types for component usage
export interface AffiliateCommissionOverride {
  type: CommissionTypes;
  value: number;
}

export interface AffiliateDiscountOverride {
  type: DiscountCodeTypes;
  value: number;
}

export const affiliateDetailsQueryKey = (userId: string | null, programId: string | null) =>
  ['affiliate-details', userId, programId] as const;

export const fetchAffiliateDetailsByUser = async (
  userId: string,
  programId: string
): Promise<AffiliateDetailsResponse> => {
  const response = await api.get(`/dashboard/affiliates/${userId}/programs/${programId}`);
  return response.data.data;
};

export const useAffiliateDetailsQuery = (
  userId: string | null,
  programId: string | null
): UseQueryResult<AffiliateDetailsResponse, Error> => {
  return useQuery<AffiliateDetailsResponse, Error>({
    queryKey: affiliateDetailsQueryKey(userId, programId),
    queryFn: () => fetchAffiliateDetailsByUser(userId!, programId!),
    enabled: !!userId && !!programId,
  });
};
